module.exports = __webpack_public_path__ + "media/IMFX_service_FXsimulations_v01.1775f98f.mp4";